import { SectionHeader, Text } from "@ttc3k/trekker";
import {
  ForwardRefExoticComponent,
  PropsWithChildren,
  RefAttributes,
  SVGProps,
} from "react";
import { Flex } from "styled-system/jsx";

type ReservationSectionProps = {
  icon: ForwardRefExoticComponent<
    Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
  >;
  title: string;
  description?: string;
} & PropsWithChildren;

export const ReservationSection = ({
  icon,
  title,
  description,
  children,
}: ReservationSectionProps) => {
  return (
    // breakInside keeps each section (Guest Info, Receipt, …) on one page in
    // the Playwright-printed order PDF; sections taller than a page still
    // paginate (browsers ignore the rule when the block can't fit).
    <Flex
      flexDir="column"
      gap="250"
      w="full"
      alignSelf="stretch"
      css={{ breakInside: "avoid", pageBreakInside: "avoid" }}
    >
      <Flex flexDir="column" gap="150">
        <SectionHeader text={title} Icon={icon} />
        {description && (
          <Text visual="bodyRegular" color="text.mid">
            {description}
          </Text>
        )}
      </Flex>
      {children}
    </Flex>
  );
};
